// extracted by mini-css-extract-plugin
module.exports = {"teacherVideo":"LiveStreamMasterVideo_teacherVideo__cgTVA"};